var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// crud/access.ts
import { Log } from "@hc/base";
import _3 from "lodash";

// schema/form.ts
import _ from "lodash";
var GraphqlFormSchema = class {
  static {
    __name(this, "GraphqlFormSchema");
  }
  name;
  meta;
  constructor(name, meta) {
    this.name = name;
    this.meta = meta;
  }
  fieldLabel(name) {
    return _.startCase(_.camelCase(name));
  }
  field(name) {
    return this.fields[name];
  }
  fieldMeta(name) {
    let result = {};
    if (this.fields[name].metas) {
      for (const meta of this.fields[name].metas) {
        _.merge(result, meta);
      }
    }
    return result;
  }
  fieldMetaValue(field, key) {
    return this.fieldMeta(field)[key];
  }
  fieldFlags(name) {
    return {
      ...this.fields[name].flags
    };
  }
  get fieldNames() {
    return Object.keys(this.meta.keys);
  }
  get fields() {
    return this.meta.keys;
  }
  get validation() {
    return Graphql.validationSchema(this.name);
  }
  get joi() {
    return this.validation.joi;
  }
};

// schema/table.ts
import _2 from "lodash";
var GraphqlTableSchema = class {
  static {
    __name(this, "GraphqlTableSchema");
  }
  name;
  meta;
  constructor(name, meta) {
    this.name = name;
    this.meta = meta;
  }
  get columns() {
    return this.meta.columns;
  }
  getRole(role) {
    if (role) return role;
    if (auth.hasState) role = auth.state.role;
    if (role) return role;
    return "admin";
  }
  getPermission(action = "select", role) {
    role = this.getRole(role);
    const p = _2.get(this.meta.permissions, `${action}.${role}`) || null;
    return p;
  }
  isPermitted(action = "select", role) {
    role = this.getRole(role);
    if (role == "admin") return true;
    const p = this.getPermission(action, role);
    if (!p) return false;
    return true;
  }
  getPermittedColumns(action = "select", role) {
    role = this.getRole(role);
    if (role == "admin") return null;
    const p = this.getPermission(action, role);
    if (!p) return [];
    const columns = [];
    if (p.columns) columns.push(...p.columns);
    if (p.computed_fields) columns.push(...p.computed_fields);
    return columns;
  }
  isColumnPermitted(column, action = "select", role) {
    role = this.getRole(role);
    if (role == "admin") return true;
    const p = this.getPermission(action, role);
    if (!p) return false;
    if (p.columns && p.columns.indexOf(column) >= 0) return true;
    if (p.computed_fields && p.computed_fields.indexOf(column) >= 0) return true;
    return false;
  }
  isAggregationPermitted(role) {
    role = this.getRole(role);
    if (role == "admin") return true;
    const p = this.getPermission("select", role);
    if (!p) return false;
    if (p.allow_aggregations) return true;
    return false;
  }
};

// schema/validation.ts
var GraphqlValidationSchema = class {
  static {
    __name(this, "GraphqlValidationSchema");
  }
  name;
  joi;
  constructor(name, joi2) {
    this.name = name;
    this.joi = joi2;
  }
  get form() {
    return Graphql.formSchema(this.name);
  }
};

// schema/graphql.ts
var GraphqlSchema = class {
  static {
    __name(this, "GraphqlSchema");
  }
  name;
  schema;
  constructor(name, schema) {
    this.name = name;
    this.schema = schema;
  }
  type(name) {
    return this.types.find((t) => t.name == name);
  }
  mutation(name) {
    return this.mutationRoot.fields.find((f) => f.name == name);
  }
  get mutationRoot() {
    return this.schema.types.find((t) => t.name == "mutation_root");
  }
  get types() {
    return this.schema.types;
  }
  get mutationType() {
    return this.schema.mutationType;
  }
  get subscriptionType() {
    return this.schema.subscriptionType;
  }
  get directives() {
    return this.schema.directives;
  }
};

// schema/registry.ts
var GraphqlSchemaRegistry = class {
  static {
    __name(this, "GraphqlSchemaRegistry");
  }
  schemas = {};
  forms = {};
  validations = {};
  tables = {};
  collections = {};
  queries = {};
  requireWhitelistedQueries = false;
  _apollo;
  get apollo() {
    if (!this._apollo) throw new Error("Apollo client not configured!");
    return this._apollo;
  }
  setApolloClient(apollo) {
    this._apollo = apollo;
  }
  addSchema(data, name = "default") {
    this.schemas[name] = new GraphqlSchema(name, data.__schema);
  }
  addSchemas(data) {
    for (const schemaName in data) {
      this.addSchema(schemaName, data[schemaName]);
    }
  }
  addValidations(data) {
    for (const schemaKey in data) {
      const schemaName = schemaKey.endsWith("_FORM") ? schemaKey.substr(0, schemaKey.lastIndexOf("_")).toLowerCase() : schemaKey.toLowerCase();
      this.validations[schemaName] = new GraphqlValidationSchema(schemaName, data[schemaKey]);
    }
  }
  addForms(data) {
    for (const schemaName in data) {
      this.forms[schemaName] = new GraphqlFormSchema(schemaName, data[schemaName]);
    }
  }
  addTables(data) {
    for (const schemaName in data) {
      this.tables[schemaName] = new GraphqlTableSchema(schemaName, data[schemaName]);
    }
  }
  addCollections(data) {
    for (const schemaKey in data) {
      const schemaName = schemaKey.replace(/[\w]([A-Z])/g, (m) => m[0] + "_" + m[1]).toLowerCase();
      this.collections[schemaName] = new CrudCollection(schemaName, data[schemaKey]);
    }
  }
  addQueries(data) {
    for (const key of Object.keys(data)) {
      this.queries[key] = data[key];
    }
  }
  query(name) {
    if (!this.queries.hasOwnProperty(name)) {
      throw new Error("Unknown graphql query: " + name);
    }
    return this.queries[name];
  }
  collection(name) {
    if (!this.collections[name]) throw new Error("Unknown crud collection: " + name);
    return this.collections[name];
  }
  tableSchema(name) {
    if (!this.tables[name]) {
      console.log(this.tables);
      throw new Error("Unknown table schema: " + name);
    }
    return this.tables[name];
  }
  formSchema(name, operation = null, state = null) {
    if (!this.forms[name]) throw new Error("Unknown form schema: " + name);
    if (state && operation) {
      const stateSchema = name + "_" + operation + "_" + state;
      if (this.forms[stateSchema]) return this.forms[stateSchema];
    }
    if (state) {
      const stateSchema = name + "_" + state;
      if (this.forms[stateSchema]) return this.forms[stateSchema];
    }
    if (operation) {
      const operationSchema = name + "_" + operation;
      if (this.forms[operationSchema]) return this.forms[operationSchema];
    }
    return this.forms[name];
  }
  validationSchema(name, operation = null, state = null) {
    if (!this.validations[name]) throw new Error("Unknown validation schema: " + name);
    if (state) {
      const stateSchema = name + "_" + state;
      if (this.validations[stateSchema]) return this.validations[stateSchema];
    }
    if (operation) {
      const operationSchema = name + "_" + operation;
      if (this.validations[operationSchema]) return this.validations[operationSchema];
    }
    return this.validations[name];
  }
  get schema() {
    return this.schemas.default;
  }
};

// schema/index.ts
var Graphql = new GraphqlSchemaRegistry();
var schema_default = Graphql;

// crud/access.ts
var log = Log.getLogger("access");
var crudAccessRules = {
  FULL_ACCESS: {
    index: true,
    read: true,
    create: true,
    update: true,
    delete: true
  },
  READ_ACCESS: {
    index: true,
    read: true,
    create: false,
    update: false,
    delete: false
  },
  NO_ACCESS: {
    index: false,
    read: false,
    create: false,
    update: false,
    delete: false
  },
  USER_NO_ACCESS: [],
  USER_FULL_ACCESS: [],
  CUSTOM_RULES: {}
};
var CrudAccess = class {
  static {
    __name(this, "CrudAccess");
  }
  constructor(user) {
    const groups = _3.uniq([].concat(Object.keys(Graphql.collections)).concat(Object.keys(crudAccessRules.CUSTOM_RULES)));
    for (const group of groups) {
      this[group] = new CrudAccessGroup(group, user);
    }
  }
};
var CrudAccessGroup = class {
  static {
    __name(this, "CrudAccessGroup");
  }
  _group;
  rules;
  _role;
  constructor(group, user) {
    this._group = group;
    this._role = user ? user.role : "anonymus";
    this.rules = {
      read: true,
      index: true,
      create: true,
      update: true,
      delete: true
    };
    if (!user) {
      this.rules = crudAccessRules.NO_ACCESS;
    } else if (user.role == "admin") {
      this.rules = {
        ...crudAccessRules.FULL_ACCESS
      };
    } else {
      if (crudAccessRules.USER_FULL_ACCESS.includes(group)) {
        this.rules = {
          ...crudAccessRules.FULL_ACCESS
        };
      } else if (crudAccessRules.USER_NO_ACCESS.includes(group)) {
        this.rules = {
          ...crudAccessRules.NO_ACCESS
        };
      } else {
        this.rules = {
          ...crudAccessRules.READ_ACCESS
        };
      }
    }
    if (user && crudAccessRules.CUSTOM_RULES[this.typename] && crudAccessRules.CUSTOM_RULES[this.typename][user.role]) {
      const customRules = crudAccessRules.CUSTOM_RULES[this.typename][user.role];
      for (const rule of Object.keys(customRules)) {
        this.rules[rule] = customRules[rule];
        Object.defineProperty(this, rule, {
          get: /* @__PURE__ */ __name(() => {
            return customRules[rule];
          }, "get")
        });
      }
    }
  }
  get collection() {
    return Graphql.collection(this._group);
  }
  get typename() {
    return this._group;
  }
  get role() {
    return this._role;
  }
  formatPermittedFields(list) {
    const permittedFields = [];
    for (const item of list) {
      const attributes = {};
      for (const field of this.collection.listFields) {
        const relation = this.collection.relation(field);
        const join = this.collection.join(field);
        if (relation) {
          attributes[field] = relation.objectTitle(item[field]);
        } else if (join) {
          attributes[field] = join.objectTitle(item[field]);
        } else {
          attributes[field] = item[field];
        }
      }
      permittedFields.push(attributes);
    }
    return permittedFields;
  }
  get read() {
    return this.rules.read;
  }
  get create() {
    return this.rules.create;
  }
  get index() {
    return this.rules.index;
  }
  get update() {
    return this.rules.update;
  }
  get delete() {
    return this.rules.delete;
  }
};

// crud/auth.ts
var CrudAuth = class {
  static {
    __name(this, "CrudAuth");
  }
  _access = new CrudAccess({
    email: "ben@hace.io"
  });
  _state;
  set access(access) {
    this._access = access;
  }
  get access() {
    if (!this._state) throw new Error("No auth state present.");
    return this._access;
  }
  get state() {
    if (!this._state) throw new Error("No auth state present.");
    return this._state;
  }
  get hasState() {
    return !!this._state;
  }
  setAuthState(state) {
    if (this._state) throw new Error("Auth state already initialized!");
    this._state = state;
  }
};
var auth = new CrudAuth();

// crud/collection.ts
import _9 from "lodash";
import gql4 from "graphql-tag";

// crud/workflow.ts
import { titleize } from "inflected";
import FileSaver from "file-saver";
import gql from "graphql-tag";
var CrudWorkflowAction = class {
  static {
    __name(this, "CrudWorkflowAction");
  }
  options;
  constructor(options = {}) {
    this.options = options;
  }
  buildActionParams(model) {
    if (this.options.buildActionParams) return this.options.buildActionParams(model);
    if (!this.options.status) return null;
    else return null;
  }
  async execute(model, params) {
    if (this.options.defaultParams) {
      params = {
        ...this.options.defaultParams,
        ...params
      };
    }
    if (this.options.handler) {
      const handlerResult = await this.options.handler(model, params, this.options);
      if (handlerResult) return handlerResult;
      else return {
        result: {}
      };
    }
    const collection = Graphql.collection(model.__typename);
    if (this.options.mutation) {
      const mutationVariables = {
        id: model.id
      };
      if (params) {
        mutationVariables.params = params;
      } else {
        const actionParams = this.buildActionParams(model);
        if (actionParams) {
          mutationVariables.params = actionParams;
        }
      }
      const mutationResult = await Graphql.apollo.mutate({
        mutation: this.options.mutation,
        variables: mutationVariables
      });
      const result = await collection.find(model.id);
      Object.assign(model, result);
      return mutationResult.data;
    } else {
      const updateParams = this.buildActionParams(model);
      const updateResult = await collection.update(model.id, updateParams);
      Object.assign(model, updateResult);
      return {
        result: updateResult
      };
    }
  }
  get name() {
    return this.options.name || this.constructor.name.replace(/Action$/, "") + " " + this.options.status;
  }
  get title() {
    return this.options.label || titleize(this.name);
  }
  get icon() {
    return this.options.icon;
  }
  isActive(model) {
    if (this.options.isActive) return this.options.isActive(model);
    return model.status != this.options.status;
  }
};
var CrudWorkflowDownloadAction = class extends CrudWorkflowAction {
  static {
    __name(this, "CrudWorkflowDownloadAction");
  }
  constructor(options) {
    super({
      confirmable: false,
      ...options,
      isActive: /* @__PURE__ */ __name((o) => true, "isActive"),
      handler: /* @__PURE__ */ __name(async (object, params) => {
        let queryString = `query($id: Int!){download: ${options.query}(id: $id) { data filename }}`;
        let queryVariables = {
          id: object.id
        };
        if (params) {
          queryString = `query($id: Int!, $params: ${options.query}_params!){download: ${options.query}(id: $id, params: $params) { data filename }}`;
          queryVariables = {
            id: object.id,
            params
          };
        }
        const result = await Graphql.apollo.query({
          query: gql(queryString),
          variables: queryVariables
        });
        if (result.errors && result.errors.length > 0) {
          throw new Error("Download failed: " + result.errors[0].message);
        }
        const byteCharacters = atob(result.data.download.data);
        const byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([
          byteArray
        ], {
          type: "application/pdf"
        });
        FileSaver.saveAs(blob, result.data.download.filename);
      }, "handler")
    });
  }
};
var CrudWorkflow = class {
  static {
    __name(this, "CrudWorkflow");
  }
  _collectionName;
  constructor(_collectionName) {
    this._collectionName = _collectionName;
  }
  get collection() {
    return Graphql.collection(this._collectionName);
  }
  get actions() {
    return this.collection.definition.workflow.actions;
  }
};

// crud/collection.ts
import { singularize, pluralize } from "inflected";

// crud/query_build_helper.ts
import _4 from "lodash";
var QueryBuildHelper = class {
  static {
    __name(this, "QueryBuildHelper");
  }
  static forceIncludeAllChildren(includeJoins) {
    return includeJoins && includeJoins["_self"]?.joinChildren;
  }
  static forceInclude(field, includeJoins) {
    return includeJoins && !!Object.keys(includeJoins).find((includeJoin) => includeJoin.split(".")[0] == field);
  }
  /**
  * A field is ignored if it is listed in ignoreJoins, unless it is explicitly included
  * (by name or via joinChildren). Includes take precedence over ignores.
  */
  static isIgnored(field, ignoreJoins, includeJoins) {
    if (!ignoreJoins || ignoreJoins.indexOf(field) < 0) return false;
    return !this.forceIncludeAllChildren(includeJoins) && !this.forceInclude(field, includeJoins);
  }
  static buildRelationOptions(relationConfig, relationCollection, includeJoinOptions) {
    const order = includeJoinOptions?.order || relationConfig.order || relationCollection.order;
    const renderedOptions = [];
    if (order && order.length > 0) {
      renderedOptions.push(`order_by: [${order.map((orders) => {
        return Object.entries(orders).map((order2) => `{${order2[0]}: ${order2[1]}}`);
      }).join(", ")}]`);
    }
    if (includeJoinOptions?.filter) {
      renderedOptions.push(`where: ${this.jsonToGraphqlParams(includeJoinOptions.filter)}`);
    }
    if (renderedOptions.length > 0) return `(${renderedOptions.join(", ")})`;
    return "";
  }
  static buildNestedIgnoreFields(currentName, currentFields) {
    let nestedFields = [];
    if (currentFields) {
      nestedFields = currentFields.map((currentField) => {
        if (!currentField || currentField.indexOf(".") == -1) return null;
        if (currentField.startsWith(currentName + ".")) return currentField.replace(currentName + ".", "");
      });
    }
    return nestedFields.filter((i) => !!i);
  }
  static buildNestedIncludeOptions(currentName, includeJoinOptions) {
    let nestedOptions = {};
    if (includeJoinOptions) {
      Object.keys(includeJoinOptions).forEach((path) => {
        if (path == currentName) {
          const currentOptions = includeJoinOptions[path];
          nestedOptions["_self"] = currentOptions;
          if (currentOptions) Object.assign(nestedOptions, currentOptions.children);
        } else if (path.startsWith(currentName + ".")) {
          const nestedPath = path.replace(currentName + ".", "");
          nestedOptions[nestedPath] = includeJoinOptions[path];
        }
      });
    }
    return nestedOptions;
  }
  static buildNestedAggregateOptions(currentName, includeJoinOptions) {
    if (!includeJoinOptions) return null;
    if (!includeJoinOptions[currentName]) return null;
    if (!includeJoinOptions[currentName].aggregate) return null;
    return includeJoinOptions[currentName].aggregate;
  }
  static applyFields(fields, apply, reorder = true) {
    for (const name of apply) {
      if (name == "-") {
        fields.splice(0, fields.length);
      } else if (name.startsWith("-")) {
        const cleanName = name.substr(1);
        if (!fields.includes(cleanName)) continue;
        fields.splice(fields.indexOf(cleanName), 1);
      } else {
        if (reorder && fields.includes(name)) {
          fields.splice(fields.indexOf(name), 1);
        }
        if (!fields.includes(name)) {
          fields.push(name);
        }
      }
    }
  }
  static jsonToGraphqlParams(input) {
    const out = [];
    if (_4.isArray(input)) {
      out.push("[");
      for (let i = 0; i < input.length; ++i) {
        const value = input[i];
        out.push(this.jsonToGraphqlParams(value));
        if (i < input.length - 1) {
          out.push(", ");
        }
      }
      out.push("]");
    } else if (_4.isObject(input)) {
      out.push("{");
      const keys = Object.keys(input);
      for (let i = 0; i < keys.length; ++i) {
        const key = keys[i];
        out.push(key);
        out.push(": ");
        const value = input[key];
        out.push(this.jsonToGraphqlParams(value));
        if (i < keys.length - 1) {
          out.push(", ");
        }
      }
      out.push("}");
    } else {
      return JSON.stringify(input, null, 2);
    }
    return out.join("");
  }
};

// util.ts
import _5 from "lodash";
import * as inflicted from "inflected";
function objectPath(input, path) {
  return _5.get(input, path);
}
__name(objectPath, "objectPath");
function titleize3(input) {
  return inflicted.titleize(input);
}
__name(titleize3, "titleize");
function camelize(input) {
  return _5.camelCase(input);
}
__name(camelize, "camelize");

// crud/facet.ts
var CrudFacet = class {
  static {
    __name(this, "CrudFacet");
  }
  name;
  definition;
  constructor(name, definition) {
    this.name = name;
    this.definition = definition;
  }
  get title() {
    return titleize3(this.name);
  }
  get default() {
    return this.definition.default;
  }
  get target() {
    return this.definition.target;
  }
  get join() {
    return this.definition.join;
  }
  get type() {
    return this.definition.type;
  }
};

// crud/transaction/base.ts
import _6 from "lodash";
import { jwtDecode } from "jwt-decode";
var RESERVED_STATEMENT_TYPE_NAMES = [
  // methods in CrudTransaction
  "addStatement",
  "execute",
  "buildGraphqlOperation",
  "log",
  // methods in CrudQuery
  "subscribe"
];
var CrudTransaction = class _CrudTransaction {
  static {
    __name(this, "CrudTransaction");
  }
  type;
  statements;
  debug;
  static logQueriesSizeKb = 10;
  role;
  constructor(type, statements = [], debug = false) {
    this.type = type;
    this.statements = statements;
    this.debug = debug;
  }
  getRoleForJwt(token) {
    if (token) {
      let payload = null;
      try {
        payload = jwtDecode(token);
      } catch (e) {
      }
      const role = payload?.["https://hasura.io/jwt/claims"]["x-hasura-default-role"];
      return role;
    }
    return null;
  }
  addStatement(...stmt) {
    const op = stmt[0];
    const args = stmt.slice(1);
    if (RESERVED_STATEMENT_TYPE_NAMES.indexOf(op) >= 0) throw new Error(`Reserved statement type ${op} for ${this.type} transaction.`);
    if (!_6.isFunction(this[op])) throw new Error(`Invalid statement type ${op} for ${this.type} transaction.`);
    this.log("REGISTER", op, args);
    this[op](...args);
  }
  buildGraphqlOperation(graphqlRequestType) {
    graphqlRequestType = graphqlRequestType || this.type;
    if (this.statements.length == 0) throw new Error("Transaction does not contain any statements.");
    const variableDefinition = [];
    const variables = {};
    const statements = [];
    const context = {
      apiToken: this.statements[0].opts.apiToken,
      whitelisted: this.statements[0].opts.whitelisted
    };
    if (Graphql.requireWhitelistedQueries && !context.whitelisted && !context.apiToken) {
      console.error(`Graphql ${this.type} does not have a jwt and is not whitelisted:`);
      for (const stmt of this.statements) {
        const filteredVariables = {};
        Object.keys(stmt.variables).forEach((key) => {
          if (stmt.variables[key] == null || stmt.variables[key] == void 0) return;
          filteredVariables[key] = stmt.variables[key];
        });
        console.error(`   ${stmt.name}(${JSON.stringify(filteredVariables)})`);
      }
      const prettyStack = [];
      const traceLines = new Error().stack.split("\n").slice(1);
      for (const traceLine of traceLines) {
        const cleanLine = traceLine.replace(/^\s*at\s/i, "");
        let loc, symbol;
        if (cleanLine.endsWith(")")) {
          loc = cleanLine.substring(cleanLine.lastIndexOf("(") + 1, cleanLine.lastIndexOf(")"));
          symbol = cleanLine.substring(0, cleanLine.lastIndexOf("("));
        } else {
          loc = cleanLine;
          symbol = "ANONYMUS";
        }
        if (loc.trim() == "<anonymous>") continue;
        const locParts = loc.split(":");
        let file, line, col;
        col = Number(locParts.pop());
        line = Number(locParts.pop());
        file = locParts.join(":");
        if (file.endsWith(".js")) continue;
        if (typeof process !== "undefined" && process.env.PWD && file.startsWith(process.env.PWD)) {
          file = file.substring(process.env.PWD.length + 1);
        }
        prettyStack.push(`    ${file} ${line}:${col}`);
      }
      console.error("Stack:");
      console.error(prettyStack.join("\n"));
      console.error("   ");
    }
    for (const index in this.statements) {
      const stmt = this.statements[index];
      const stmtScope = [];
      this.log("STMT", index, stmt);
      for (const variableName of Object.keys(stmt.types)) {
        variableDefinition.push(`$i${index}_${variableName}: ${stmt.types[variableName]}`);
        variables[`i${index}_${variableName}`] = _6.has(stmt.variables, variableName) ? stmt.variables[variableName] : null;
        stmtScope.push(`${variableName}: $i${index}_${variableName}`);
      }
      const stmtCode = `  i${index}: ${stmt.name}(${stmtScope.join(", ")}){${stmt.body}}`;
      statements.push(stmtCode);
      const kbSize = stmtCode.length / 1024;
      if (_CrudTransaction.logQueriesSizeKb != null && kbSize >= _CrudTransaction.logQueriesSizeKb) {
        const queryHead = stmtCode.substring(0, stmtCode.indexOf("{")).trim();
        console.log(`CrudTransaction large statement name=${stmt.name} query_size=${kbSize.toFixed(2)}kb => ${queryHead}`);
      }
    }
    const code = `${graphqlRequestType} crud_tx(${variableDefinition.join(", ")}){
${statements.join("\n")}
}`;
    this.log("QUERY", code);
    this.log("VARIABLES", variables);
    return {
      type: this.type,
      code,
      variables,
      context
    };
  }
  transformResult(data) {
    const result = [];
    for (const index in this.statements) {
      const stmt = this.statements[index];
      let item = data && data.hasOwnProperty(`i${index}`) ? data[`i${index}`] : null;
      if (stmt.transform) {
        for (const transform of stmt.transform) {
          if (_6.isFunction(transform)) {
            item = transform(item);
          } else {
            item = _6.get(item, transform);
          }
        }
      }
      result.push(item);
    }
    return result;
  }
  log(...msg) {
    if (this.debug) {
      console.log(...msg);
    }
  }
};

// crud/transaction/query.ts
import gql2 from "graphql-tag";
import * as _7 from "lodash";
var CrudQuery = class extends CrudTransaction {
  static {
    __name(this, "CrudQuery");
  }
  constructor() {
    super("query", []);
  }
  async execute() {
    const { code, variables, context } = this.buildGraphqlOperation();
    const apolloResult = await Graphql.apollo.query({
      query: gql2(code),
      variables,
      context
    });
    this.log("ERRORS", apolloResult.errors);
    return this.transformResult(apolloResult.data);
  }
  subscribe(handler) {
    const { code, variables, context } = this.buildGraphqlOperation("subscription");
    const apolloSubscription = Graphql.apollo.subscribe({
      query: gql2(code),
      variables,
      context
    });
    const transaction = this;
    return apolloSubscription.subscribe({
      async next(apolloResult) {
        const result = transaction.transformResult(apolloResult.data);
        handler.result(result);
      },
      error(err) {
        handler.error(err);
      }
    });
  }
  find(collectionName, id, opts) {
    opts = opts ? _7.cloneDeep(opts) : {};
    const collection = Graphql.collection(collectionName);
    const fields = opts.fields || collection.buildFetchFields("find", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    this.statements.push({
      name: `${collection.typename}_by_pk`,
      body: fields.join(" "),
      variables: {
        id
      },
      types: {
        id: `${collection.idType}!`
      },
      opts
    });
  }
  list(collectionName, opts) {
    opts = opts ? _7.cloneDeep(opts) : {};
    const collection = Graphql.collection(collectionName);
    const fields = opts.fields || collection.buildFetchFields("list", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    const where = opts.filter || opts.where || {};
    const limit = opts.limit;
    const offset = opts.offset || null;
    const order_by = opts.order || collection.definition.order || (fields.indexOf("sort_index") >= 0 ? [
      {
        "sort_index": "asc"
      }
    ] : [
      {
        "id": "asc"
      }
    ]);
    if (opts.search) {
      collection.buildSearchFilter(opts.search, where);
    }
    this.statements.push({
      name: `${collection.typename}`,
      body: fields.join(" "),
      variables: {
        where,
        limit,
        offset,
        order_by
      },
      types: {
        where: `${collection.typename}_bool_exp`,
        offset: `Int`,
        limit: `Int`,
        order_by: `[ ${collection.typename}_order_by!]`
      },
      opts
    });
  }
  aggregate(collectionName, opts = {}) {
    const collection = Graphql.collection(collectionName);
    const fields = opts.fields || [
      "id"
    ];
    const method = opts.method || "sum";
    this.statements.push({
      name: `${collection.typename}_aggregate`,
      opts,
      body: `aggregate { 
        ${method} { 
          ${fields.join(", ")} 
        }
      }`,
      variables: {
        where: opts.where
      },
      types: {
        where: `${collection.typename}_bool_exp`
      },
      transform: [
        `aggregate`
      ]
    });
  }
  count(collectionName, opts) {
    opts = opts ? _7.cloneDeep(opts) : {};
    const collection = Graphql.collection(collectionName);
    const where = opts.filter || opts.where || {};
    if (opts.search) {
      collection.buildSearchFilter(opts.search, where);
    }
    this.statements.push({
      name: `${collection.typename}_aggregate`,
      opts,
      body: `aggregate { count }`,
      variables: {
        where
      },
      types: {
        where: `${collection.typename}_bool_exp`
      },
      transform: [
        "aggregate.count"
      ]
    });
  }
};

// crud/transaction/mutation.ts
import _8 from "lodash";
import gql3 from "graphql-tag";
var DEFAULT_OPTIONS_UPDATE = {};
var DEFAULT_OPTIONS_CREATE = {};
var DEFAULT_OPTIONS_DELETE = {};
var CrudMutation = class extends CrudTransaction {
  static {
    __name(this, "CrudMutation");
  }
  constructor() {
    super("mutation", []);
  }
  async execute() {
    const { code, variables, context } = this.buildGraphqlOperation();
    const apolloResult = await Graphql.apollo.mutate({
      mutation: gql3(code),
      variables,
      context
    });
    this.log("ERRORS", apolloResult.errors);
    return this.transformResult(apolloResult.data);
  }
  update(collectionName, id, data, opts) {
    const collection = Graphql.collection(collectionName);
    if (collection.type == "view") {
      throw new Error(`Cannot update view collection: ${collection.name}`);
    }
    opts = {
      ...DEFAULT_OPTIONS_UPDATE,
      ...opts
    };
    const fields = opts.fields || collection.buildFetchFields("update", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    const where = {
      id: {
        _eq: Number(id)
      }
    };
    const object = {
      ...data
    };
    this.statements.push({
      name: `update_${collection.typename}`,
      opts,
      body: opts.skipReturn ? "affected_rows" : `returning {${fields.join(" ")}}`,
      variables: {
        where,
        _set: object
      },
      types: {
        where: `${collection.typename}_bool_exp!`,
        _set: `${collection.typename}_set_input!`
      },
      transform: [
        "returning.0"
      ]
    });
  }
  updateAll(collectionName, queryOrIds, data, opts) {
    const collection = Graphql.collection(collectionName);
    if (collection.type == "view") {
      throw new Error(`Cannot batch update view collection: ${collection.name}`);
    }
    opts = {
      ...DEFAULT_OPTIONS_UPDATE,
      ...opts
    };
    const fields = opts.fields || collection.buildFetchFields("update", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    const where = _8.isArray(queryOrIds) ? {
      id: {
        _in: queryOrIds
      }
    } : queryOrIds;
    const object = {
      ...data
    };
    this.statements.push({
      name: `update_${collection.typename}`,
      opts,
      body: opts.skipReturn ? "affected_rows" : `returning {${fields.join(" ")}}`,
      variables: {
        where,
        _set: object
      },
      types: {
        where: `${collection.typename}_bool_exp!`,
        _set: `${collection.typename}_set_input!`
      },
      transform: [
        "returning"
      ]
    });
  }
  create(collectionName, data, opts) {
    const collection = Graphql.collection(collectionName);
    if (collection.type == "view") {
      throw new Error(`Cannot create in view collection: ${collection.name}`);
    }
    opts = {
      ...DEFAULT_OPTIONS_CREATE,
      ...opts
    };
    const fields = opts.fields || collection.buildFetchFields("create", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    const objects = [
      data
    ];
    this.statements.push({
      name: `insert_${collection.typename}`,
      opts,
      body: opts.skipReturn ? "affected_rows" : `returning {${fields.join(" ")}}`,
      variables: {
        objects
      },
      types: {
        objects: `[${collection.typename}_insert_input!]!`
      },
      transform: [
        "returning.0"
      ]
    });
  }
  delete(collectionName, id, opts) {
    const collection = Graphql.collection(collectionName);
    if (collection.type == "view") {
      throw new Error(`Cannot delete from view collection: ${collection.name}`);
    }
    opts = {
      ...DEFAULT_OPTIONS_DELETE,
      ...opts
    };
    const fields = opts.fields || collection.buildFetchFields("delete", this.getRoleForJwt(opts?.apiToken), opts.skipJoins, opts.includeDefaultJoins, opts.ignoreJoins, opts.includeJoins, opts.aggregate, opts.nestingLevel);
    const ids = _8.isArray(id) ? id : [
      id
    ];
    if (ids.length == 0) throw new Error("Cannot delete without ids because this will cause ALL records to be deleted!");
    const where = {
      id: {
        _in: ids
      }
    };
    this.statements.push({
      name: `delete_${collection.typename}`,
      opts,
      body: opts.skipReturn ? "affected_rows" : `returning {${fields.join(" ")}}`,
      variables: {
        where
      },
      types: {
        where: `${collection.typename}_bool_exp!`
      },
      transform: [
        "returning",
        (r) => _8.isArray(id) ? r : r && r[0] || null
      ]
    });
  }
};

// crud/collection.ts
var CrudCollection = class {
  static {
    __name(this, "CrudCollection");
  }
  _typename;
  _definition;
  objectTitleTemplate;
  _workflow;
  _facets;
  constructor(_typename, _definition) {
    this._typename = _typename;
    this._definition = _definition;
    if (this._definition.objectTitle) {
      if (typeof this._definition.objectTitle == "function") {
        this.objectTitleTemplate = this._definition.objectTitle;
      } else {
        this.objectTitleTemplate = _9.template(this._definition.objectTitle);
      }
    }
    if (this._definition.workflow) {
      this._workflow = new CrudWorkflow(this.typename);
    }
    this._facets = [];
    if (this._definition.facets) {
      for (const facetKey of this.facetNames) {
        this._facets.push(new CrudFacet(facetKey, this.def("facets." + facetKey)));
      }
    }
  }
  async find(id, opts = {}) {
    const query = new CrudQuery();
    query.find(this.name, id, opts);
    const [result] = await query.execute();
    return result;
  }
  subscribeObject(id, opts = {}, handler) {
    const query = new CrudQuery();
    query.find(this.name, id, opts);
    return query.subscribe({
      result: /* @__PURE__ */ __name((result) => handler.result(result[0]), "result"),
      error: /* @__PURE__ */ __name((err) => handler.error(err), "error")
    });
  }
  async list(opts = {}) {
    const query = new CrudQuery();
    query.list(this.name, opts);
    const [result] = await query.execute();
    if (result.length > 1e3) {
      const debugOpts = _9.cloneDeep(opts);
      delete debugOpts.apiToken;
      console.log("CrudCollection large list result", this.name, result.length, JSON.stringify(debugOpts).substring(0, 128));
    }
    return result;
  }
  subscribeList(opts = {}, handler) {
    const query = new CrudQuery();
    query.list(this.name, opts);
    return query.subscribe({
      result: /* @__PURE__ */ __name((result) => handler.result(result[0]), "result"),
      error: /* @__PURE__ */ __name((err) => handler.error(err), "error")
    });
  }
  async aggregate(opts = {}) {
    const query = new CrudQuery();
    query.aggregate(this.name, opts);
    const [result] = await query.execute();
    return result;
  }
  async create(object, opts = {}) {
    const mutation = new CrudMutation();
    mutation.create(this.name, object, opts);
    const [result] = await mutation.execute();
    return result;
  }
  async update(id, object, opts = {}) {
    const mutation = new CrudMutation();
    mutation.update(this.name, id, object, opts);
    const [result] = await mutation.execute();
    return result;
  }
  async delete(ids, opts = {}) {
    const mutation = new CrudMutation();
    mutation.delete(this.name, ids, opts);
    const [result] = await mutation.execute();
    return result;
  }
  async first(opts = {}) {
    const result = await this.list({
      ...opts,
      limit: 1
    });
    return result[0];
  }
  async updateAll(queryOrIds, data, opts = {}) {
    const mutation = new CrudMutation();
    mutation.updateAll(this.name, queryOrIds, data, opts);
    const [result] = await mutation.execute();
    return result;
  }
  async count(opts = {}) {
    const query = new CrudQuery();
    query.count(this.name, opts);
    const [result] = await query.execute();
    return result;
  }
  async facetData() {
    const facets = await this.apollo.query({
      query: gql4(`
        query facets($collection: String!) {
          facets(collection: $collection) {
            name
            title
            collection
            type
            target
            join
            default
            initial
            values {
              value
              label
            }
          }
        }
      `),
      variables: {
        collection: this.name
      }
    });
    return facets.data && facets.data.facets ? facets.data.facets : [];
  }
  objectTitle(o, caller) {
    if (!o) return null;
    if (this.objectTitleTemplate) {
      try {
        return this.objectTitleTemplate(o, caller);
      } catch (e) {
      }
    }
    return `${this.typename}(${o.id})`;
  }
  objectBadges(o) {
    const badges = [];
    if (o.status) {
      badges.push({
        name: "status",
        value: o.status
      });
    }
    if (this._definition.objectBadges) {
      badges.push(...this._definition.objectBadges(o));
    }
    return badges;
  }
  relation(name) {
    if (!this._definition.relations || !this._definition.relations[name]) return null;
    return Graphql.collections[this._definition.relations[name].collection];
  }
  join(name) {
    if (!this._definition.joins || !this._definition.joins[name]) return null;
    return Graphql.collections[this._definition.joins[name].collection];
  }
  joinNameForKey(key) {
    if (!this._definition.joins) return null;
    for (const joinName of this.joinNames) {
      const joinKey = this._definition.joins[joinName].foreignKey || `${joinName}_id`;
      if (key == joinKey) return joinName;
    }
    return null;
  }
  joinPath(path) {
    let currentCollection = this;
    const items = path.split(".");
    const result = [];
    for (const item of items) {
      const joinKey = currentCollection.joinKey(item);
      const nextCollection = currentCollection.join(item);
      result.push({
        collection: nextCollection,
        key: joinKey,
        name: item
      });
      currentCollection = nextCollection;
    }
    return result;
  }
  joinKey(name) {
    let key = this.def("joins." + name + ".foreignKey");
    if (!key) key = name + "_id";
    return key;
  }
  formActions(slot) {
    return this._definition.form && this._definition.form.actions && this._definition.form.actions[slot] ? this._definition.form.actions[slot] : [];
  }
  registerFormAction(slot, action) {
    if (!this._definition.form) this._definition.form = {};
    if (!this._definition.form.actions) this._definition.form.actions = {};
    if (!this._definition.form.actions[slot]) this._definition.form.actions[slot] = [];
    this._definition.form.actions[slot].push(action);
    return this;
  }
  registerWorkflowAction(action) {
    if (!this._definition.workflow) this._definition.workflow = {};
    if (!this._definition.workflow.actions) this._definition.workflow.actions = [];
    this._definition.workflow.actions.push(action);
    return this;
  }
  registerComponents(definition) {
    for (const view in definition) {
      for (const scope in definition[view]) {
        if (!this.definition.components) this.definition.components = {};
        if (!this.definition.components[view]) this.definition.components[view] = {};
        if (!this.definition.components[view][scope]) this.definition.components[view][scope] = [];
        if (_9.isArray(definition[view][scope])) {
          this.definition.components[view][scope] = _9.uniq(this.definition.components[view][scope].concat(definition[view][scope]));
        } else {
          this.definition.components[view][scope].push(definition[view][scope]);
        }
      }
    }
    return this;
  }
  components(view, slot) {
    if (!this.hasComponents(view, slot)) return null;
    return this._definition.components[view][slot];
  }
  pageComponent(part, view) {
    return _9.get(this._definition, `components.page.${part}.${view}`);
  }
  hasComponents(view, slot) {
    return !!this._definition.components && !!this._definition.components[view] && !!this._definition.components[view][slot];
  }
  def(path, defaultValue = void 0) {
    return _9.get(this._definition, path) || defaultValue;
  }
  relationKey(relation) {
    let key = this.def("relations." + relation + ".key");
    if (!key) key = this.relation(relation).parentKey;
    if (!key) throw new Error("Missing relation key collection " + this.name + " relation " + relation);
    return key;
  }
  buildFetchFields(operation, role, skipJoins = false, includeDefaultJoins = false, ignoreJoins = null, includeJoins = {}, aggregate, maxNestingLevel, nestingLevel = 0) {
    if (nestingLevel > 15) {
      throw new Error("Max nesting level of collection relations reached!");
    }
    let preFields = new Array();
    let postFields = new Array();
    let baseFields = new Array();
    if (this.isColumnPermitted("id", role)) {
      preFields.push("id");
    }
    for (const baseField of this.baseFields) {
      if (this.isColumnPermitted(baseField, role)) {
        baseFields.push(baseField);
      }
    }
    if (this._definition.timestampFields) {
      for (const timeField of this._definition.timestampFields) {
        if (this.isColumnPermitted(timeField, role)) {
          preFields.push(timeField);
        }
      }
    } else {
      if (this.isColumnPermitted("created_at", role)) {
        preFields.push("created_at");
      }
      if (this.isColumnPermitted("updated_at", role)) {
        preFields.push("updated_at");
      }
    }
    if (nestingLevel == 0 && this._definition.parent && this.joinNames.indexOf(this._definition.parent) == -1 && !QueryBuildHelper.forceIncludeAllChildren(includeJoins)) {
      const parentCollection = this.joins[this.parent];
      if (parentCollection) {
        const parentSubFields = parentCollection.buildFetchFields(operation, role, true, false, this._definition.joins[this.parent].ignoreJoins, null, null, maxNestingLevel, nestingLevel + 1);
        const fragment = this.parent + "{ " + parentSubFields.join(" ") + " }";
        preFields.push(fragment);
      } else {
        console.error("Cannot fetch parent %s due to missing joins in %s", this.parent, this.name);
      }
    }
    const nestedFields = maxNestingLevel == null || maxNestingLevel == void 0 || nestingLevel < maxNestingLevel;
    if (nestedFields && this._definition.joins) {
      for (const joinName in this._definition.joins) {
        const joinConfig = this._definition.joins[joinName];
        const forceLoadDefaultJoin = includeDefaultJoins && joinConfig.default;
        const joinCollection = Graphql.collection(joinConfig.collection);
        const foreignKey = joinConfig.foreignKey || joinName + "_id";
        if (!this.isColumnPermitted(foreignKey, role)) {
          continue;
        }
        preFields.push(foreignKey);
        if (joinConfig.skip) {
          continue;
        }
        if (QueryBuildHelper.isIgnored(joinName, ignoreJoins, includeJoins)) {
          continue;
        }
        if (!forceLoadDefaultJoin && !QueryBuildHelper.forceIncludeAllChildren(includeJoins)) {
          if (skipJoins && !QueryBuildHelper.forceInclude(joinName, includeJoins)) continue;
        }
        if (!joinCollection.canSelect) {
          continue;
        }
        const nestedIgnoreJoins = QueryBuildHelper.buildNestedIgnoreFields(joinName, ignoreJoins).concat(joinConfig.ignoreJoins || []);
        const nestedIncludeJoins = QueryBuildHelper.buildNestedIncludeOptions(joinName, includeJoins);
        const nestedDefaultJoins = nestedIgnoreJoins.length > 0 ? false : includeDefaultJoins;
        const nestedAggregate = QueryBuildHelper.buildNestedAggregateOptions(joinName, includeJoins);
        const nestedFields2 = joinCollection.buildFetchFields(operation, role, skipJoins, nestedDefaultJoins, nestedIgnoreJoins, nestedIncludeJoins, nestedAggregate, maxNestingLevel, nestingLevel + 1);
        if (nestedFields2.length == 0) {
          continue;
        }
        const fragment = `${joinName}{${nestedFields2.join(" ")}}`;
        preFields.push(fragment);
      }
    }
    if (nestedFields && this._definition.relations) {
      for (const relationName in this._definition.relations) {
        const relationConfig = this._definition.relations[relationName];
        const relationCollection = Graphql.collection(relationConfig.collection);
        if (!relationCollection.canSelect) {
          continue;
        }
        if (QueryBuildHelper.isIgnored(relationName, ignoreJoins, includeJoins)) continue;
        if (!QueryBuildHelper.forceIncludeAllChildren(includeJoins)) {
          if (!relationConfig.join && !QueryBuildHelper.forceInclude(relationName, includeJoins)) continue;
          if (skipJoins && !QueryBuildHelper.forceInclude(relationName, includeJoins)) continue;
        }
        const includeJoinOptions = includeJoins ? includeJoins[relationName] : null;
        const relationFields = relationCollection.buildFetchFields(operation, role, skipJoins, includeDefaultJoins, QueryBuildHelper.buildNestedIgnoreFields(relationName, ignoreJoins).concat(relationConfig.ignoreJoins || []), QueryBuildHelper.buildNestedIncludeOptions(relationName, includeJoins), QueryBuildHelper.buildNestedAggregateOptions(relationName, includeJoins), maxNestingLevel, nestingLevel + 1);
        if (relationFields.length == 0) {
          continue;
        }
        const fragment = `${relationName}${QueryBuildHelper.buildRelationOptions(relationConfig, relationCollection.definition, includeJoinOptions)}{${relationFields.join(" ")}}`;
        preFields.push(fragment);
      }
    }
    if (nestedFields && aggregate) {
      if (aggregate.count) {
        for (const countRelation of aggregate.count) {
          if (this.relation(countRelation) == null) throw new Error("Cannot aggregate on non-existing relation " + countRelation + " in " + this.name);
          const countFragment = `${countRelation}_aggregate {aggregate {count}}`;
          preFields.push(countFragment);
        }
      }
    }
    if (this.formSchema) {
      for (const fieldName of this.formSchema.fieldNames) {
        const formField = this.formSchema.field(fieldName);
        if (fieldName == "__typename") continue;
        if (formField.type == "relation") continue;
        if (this.formSchema.fieldMetaValue(fieldName, operation) === false) continue;
        if (this.isColumnPermitted(fieldName, role)) postFields.push(fieldName);
      }
    }
    const fields = _9.chain([]).concat(preFields).concat(baseFields).concat(postFields).uniq().value();
    if (nestingLevel == 0 && fields.length == 0) {
      throw new Error("No root fetch fields available for collection " + this.name + " with role " + role);
    }
    return fields;
  }
  buildSearchFilter(searchTerm, filter) {
    if (!this.searchFields) throw new Error("Cannot search collection without searchFields defined: " + this.typename);
    const searchWords = searchTerm.trim().split(/\s+/).filter((t) => t.length > 0);
    if (searchWords.length == 0) return;
    const searchFilter = searchWords.map((word) => {
      const wordConditions = [];
      const relationConditions = {};
      for (const searchField of this.searchFields) {
        if (searchField.indexOf(".") >= 0) {
          const parts = searchField.split(".");
          const relation = parts.shift();
          const field = parts.join(".");
          if (!relationConditions[relation]) relationConditions[relation] = [];
          relationConditions[relation].push({
            [field]: {
              _ilike: "%" + word + "%"
            }
          });
        } else if (searchField.indexOf(":") >= 0) {
          const [fieldName, fieldType] = searchField.split(":");
          switch (fieldType) {
            case "number":
              if (_9.isNumber(word)) wordConditions.push({
                [fieldName]: {
                  _eq: word
                }
              });
              break;
            default:
              throw new Error("Unknown search field type: " + fieldType);
          }
        } else {
          wordConditions.push({
            [searchField]: {
              _ilike: "%" + word + "%"
            }
          });
        }
      }
      for (const relation of Object.keys(relationConditions)) {
        const condition = relationConditions[relation];
        wordConditions.push(condition.length > 1 ? {
          [relation]: {
            _or: condition
          }
        } : {
          [relation]: condition[0]
        });
      }
      return {
        _or: wordConditions
      };
    });
    filter["_and"] = (filter["_and"] || []).concat(searchFilter);
  }
  get facets() {
    return this._facets;
  }
  get facetNames() {
    return Object.keys(this.definition.facets);
  }
  get name() {
    return this._typename;
  }
  get hidden() {
    return !!this.definition.hidden;
  }
  get apollo() {
    return Graphql.apollo;
  }
  get definition() {
    return this._definition;
  }
  get typename() {
    return this._typename;
  }
  get workflow() {
    return this._workflow;
  }
  get parent() {
    return this._definition.parent;
  }
  get type() {
    return this._definition.type || "table";
  }
  get titleSingular() {
    return singularize(this._definition.title);
  }
  get title() {
    return pluralize(this._definition.title);
  }
  get titleShort() {
    return this._definition.titleShort;
  }
  get parentCollection() {
    if (!this.parent) return null;
    const parentCollection = Graphql.collections[this.parent];
    if (parentCollection) {
      return parentCollection;
    }
    if (this.joins[this.parent]) {
      return this.join(this.parent);
    }
    throw new Error("Cannot find parent collection in " + this.name + " parent " + this.parent);
  }
  get parentRelation() {
    if (!this.parentCollection) return null;
    for (const relationName of this.parentCollection.relationNames) {
      const relation = this.parentCollection.definition.relations[relationName];
      if (relation.collection == this.typename) return relationName;
    }
    throw new Error("Parent relation not found for collection " + this.typename);
  }
  get relationNames() {
    if (!this._definition.relations) return [];
    return Object.keys(this._definition.relations);
  }
  get relations() {
    if (!this._definition.relations) return {};
    return _9.zipObject(this.relationNames, Object.values(this._definition.relations).map((r) => Graphql.collections[r.collection]));
  }
  get joinNames() {
    if (!this._definition.joins) return [];
    return Object.keys(this._definition.joins);
  }
  get joins() {
    if (!this._definition.joins) return {};
    return _9.zipObject(this.joinNames, Object.values(this._definition.joins).map((r) => Graphql.collections[r.collection]));
  }
  get parentKey() {
    if (this._definition.parent) {
      if (this._definition.parentKey) {
        return this._definition.parentKey;
      } else {
        return this.parent + "_id";
      }
    }
    return null;
  }
  get baseFields() {
    return _9.without(this._definition.fields, ...this.joinNames) || [];
  }
  get fetchFields() {
    return this.buildFetchFields("list", null, false, null, null);
  }
  get listFields() {
    const fields = this.baseFields.concat();
    if (this._definition.list && this._definition.list.fields) {
      QueryBuildHelper.applyFields(fields, this._definition.list.fields);
    }
    return _9.uniq(fields);
  }
  get viewFields() {
    let fields = this.baseFields;
    for (const formField of this.formFields) {
      fields.push(formField);
    }
    fields = _9.uniq(fields);
    if (this._definition.view && this._definition.view.fields) {
      QueryBuildHelper.applyFields(fields, this._definition.view.fields);
    }
    return _9.uniq(fields);
  }
  get formFields() {
    let fields = this.baseFields;
    if (this.formSchema) {
      fields = this.formSchema.fieldNames;
      fields = _9.without(fields, "__typename", "id");
    }
    return _9.uniq(fields);
  }
  get searchFields() {
    return this._definition.searchFields || this._definition.fields;
  }
  get searchOrderBy() {
    const order = {};
    for (const field of this.searchFields) {
      if (field.indexOf(".") >= 0) {
        const parts = field.split(".");
        const last = parts.pop();
        const rootPart = {};
        let nested = rootPart;
        for (const part of parts) {
          nested[part] = {};
          nested = nested[part];
        }
        nested[last] = "asc_nulls_last";
        order[parts[0]] = rootPart[parts[0]];
      } else {
        order[field] = "asc_nulls_last";
      }
    }
    return order;
  }
  get idType() {
    return this._definition.idType || "Int";
  }
  formField(name) {
    if (!this.formSchema) return null;
    return this.formSchema.field(name);
  }
  facet(name) {
    const facet = this._facets.find((f) => f.name == name);
    if (!facet) throw new Error("Unknown facet: " + name);
    return facet;
  }
  get tableName() {
    if (this.definition.schema) {
      return this.definition.schema + "." + this.name.substring(this.definition.schema.length + 1);
    } else {
      return `public.${this.name}`;
    }
  }
  get formMeta() {
    if (!this.formSchema || !this.formSchema.meta.metas) return {};
    return this.formSchema.meta.metas.reduce((r, c) => Object.assign(r, c), {});
  }
  get tableSchema() {
    return Graphql.tableSchema(this.typename);
  }
  get validationSchema() {
    return Graphql.validationSchema(this.typename);
  }
  get formSchema() {
    try {
      return Graphql.formSchema(this.typename);
    } catch {
      return null;
    }
  }
  get listDisplayFieldFilter() {
    if (!this.definition.list) return;
    return this.definition.list.displayField;
  }
  getPermission(action, role) {
    return Graphql.tables[this.name].getPermission(action, role);
  }
  isPermitted(action, role) {
    return Graphql.tables[this.name].isPermitted(action, role);
  }
  getPermittedColumns(action, role) {
    return Graphql.tables[this.name].getPermittedColumns(action, role);
  }
  isColumnPermitted(column, role, action) {
    return Graphql.tables[this.name].isColumnPermitted(column, action, role);
  }
  isAggregationPermitted(role) {
    return Graphql.tables[this.name].isAggregationPermitted(role);
  }
  get canInsert() {
    return this.isPermitted("insert");
  }
  get canSelect() {
    return this.isPermitted("select");
  }
  get canUpdate() {
    return this.isPermitted("update");
  }
  get canDelete() {
    return this.isPermitted("delete");
  }
  get canAggregate() {
    return this.isAggregationPermitted();
  }
};

// crud/form_schema_builder.ts
import _10 from "lodash";
var IGNORE_FIELDS = [
  "id",
  "__typename"
];
var CrudFormSchemaBuilder = class {
  static {
    __name(this, "CrudFormSchemaBuilder");
  }
  collection;
  formSchema;
  fields;
  groups;
  debug = false;
  disableGrid = false;
  parentKey = null;
  parentId = null;
  constructor(options) {
    _10.extend(this, options);
  }
  build() {
    const fieldsSchema = {
      fields: [],
      groups: []
    };
    this.log("FORM", this.collection.typename);
    if (!this.formSchema || !this.formSchema.fields) {
      throw new Error("No data schema defined for: " + this.collection.typename + "!");
    }
    let ignore = [];
    ignore = ignore.concat(IGNORE_FIELDS);
    if (this.parentKey) {
      console.log("IGNORE PARENT", this.collection.typename, this.parentKey, this.parentId);
      ignore.push(this.parentKey);
    }
    if (this.fields) ignore = ignore.concat(_10.without(this.formSchema.fieldNames, ...this.fields));
    for (const fieldName of this.formSchema.fieldNames) {
      const joiMeta = _10.merge({}, this.formSchema.fields[fieldName]);
      if (joiMeta.flags) {
        _10.merge(joiMeta, joiMeta.flags);
      }
      if (joiMeta.metas) {
        for (const metaItem of joiMeta.metas) {
          _10.merge(joiMeta, metaItem);
        }
      }
      this.log("   FIELD %s = %o", fieldName, joiMeta);
      if (ignore.indexOf(fieldName) >= 0) {
        this.log("     -> ignored");
        continue;
      }
      const field = {
        model: fieldName,
        label: joiMeta.label || _10.startCase(_10.camelCase(fieldName)),
        disabled: false,
        readonly: false,
        visible: true
      };
      if (joiMeta.readonly) {
        field.readonly = true;
        field.disabled = true;
      }
      if (joiMeta.hidden) {
        field.visible = false;
      }
      if (joiMeta.calculated) {
        field.disabled = true;
        field.visible = false;
      }
      if (!this.disableGrid) {
        field.styleClasses = "col-md-" + (joiMeta.grid || 12);
      }
      delete joiMeta["metas"];
      if (joiMeta.editor) {
        this.log("   editor=", joiMeta.editor);
        field.type = joiMeta.editor;
      } else {
        switch (joiMeta.type) {
          case "relation":
            field.visible = false;
            field.disabled = true;
            break;
          case "join":
            field.type = "join";
            if (joiMeta.collection) field.collection = joiMeta.collection;
            else throw new Error("Join field without collection: " + fieldName);
            if (joiMeta.constrain) field.constrain = joiMeta.constrain;
            field.label = field.label.replace(/\s*id$/i, "");
            break;
          case "asset":
            field.type = "asset";
            if (joiMeta.policy) field.policy = joiMeta.policy;
            else throw new Error("Asset field without policy: " + fieldName);
            if (joiMeta.accept !== void 0) field.accept = joiMeta.accept;
            if (joiMeta.maxSize !== void 0) field.maxSize = joiMeta.maxSize;
            field.label = field.label.replace(/\s*id$/i, "");
            break;
          case "text":
            field.type = "textArea";
            field.rows = joiMeta.rows || 5;
            break;
          case "json":
            field.type = "json";
            field.rows = joiMeta.rows || 5;
            break;
          case "number":
            field.type = "input";
            field.inputType = "number";
            break;
          case "percent":
            field.type = "percent";
            break;
          case "color":
            field.type = "color";
            break;
          case "enum":
            field.type = "select";
            field.values = joiMeta.allow.filter((v) => v !== null).map((key) => {
              if (joiMeta.itemMap && joiMeta.itemMap[key]) {
                return {
                  id: key,
                  name: joiMeta.itemMap[key]
                };
              } else {
                return key;
              }
            });
            break;
          case "string":
            field.type = "input";
            field.inputType = "text";
            break;
          case "date":
            field.type = "datepicker";
            field.format = "YYYY-MM-DD";
            break;
          case "time":
            field.type = "timepicker";
            field.format = "HH:mm";
            break;
          case "boolean":
            field.type = "switch";
            break;
          case "checklist":
            field.type = "checklist";
            field.listBox = true;
            field.values = joiMeta.items || [];
            break;
          case "phone":
            field.type = "phone";
            break;
          case "list":
            field.type = "list";
            break;
          default:
            this.log("Unsupported schema type:" + joiMeta.type);
            field.type = "input";
            field.inputType = "text";
        }
      }
      field.default = joiMeta.default;
      if (joiMeta.presence == "required") {
        field.required = true;
      }
      const joiKey = this.formSchema.joi.$_terms.keys.find((k) => k.key == fieldName);
      field.validator = (value, field2, model) => {
        const { error } = joiKey.schema.validate(value);
        if (!error) {
          return [];
        }
        let message = error.message;
        if (message.startsWith('"value"')) {
          message = message.substr(7, message.length).trim();
        }
        return [
          message
        ];
      };
      field.buttons = [];
      if (this.collection.formActions(fieldName)) {
        field.buttons = this.collection.formActions(fieldName);
      }
      field.joi = joiMeta;
      fieldsSchema.fields.push(field);
    }
    if (this.groups) {
      const grouped = [];
      for (const group of this.groups) {
        const groupFields = fieldsSchema.fields.filter((field) => group.fields.indexOf(field.model) >= 0);
        grouped.push({
          legend: group.title,
          fields: groupFields
        });
      }
      fieldsSchema.fields = null;
      fieldsSchema.groups = grouped;
    }
    return fieldsSchema;
  }
  log(...args) {
    if (!this.debug) return;
    console.log(...args);
  }
};

// crud/schema.ts
var CrudSchema = class {
  static {
    __name(this, "CrudSchema");
  }
  registry;
  constructor(registry) {
    this.registry = registry;
  }
  collection(name) {
    return this.registry.collection(name);
  }
  title(object) {
    return this.collection(object.__typename).objectTitle(object);
  }
  async list(collection, opts) {
    return await this.registry.collection(collection).list(opts);
  }
  async first(collection, opts) {
    return await this.registry.collection(collection).first(opts);
  }
  async count(collection, opts) {
    return await this.registry.collection(collection).count(opts);
  }
  async find(collection, id, opts) {
    return await this.registry.collection(collection).find(id, opts);
  }
  async aggregate(collection, opts) {
    return await this.registry.collection(collection).aggregate(opts);
  }
  async create(collection, object, opts) {
    return await this.registry.collection(collection).create(object, opts);
  }
  async update(collection, id, object, opts) {
    return await this.registry.collection(collection).update(id, object, opts);
  }
  async updateAll(collection, idsOrFilter, data, opts) {
    return await this.registry.collection(collection).updateAll(idsOrFilter, data, opts);
  }
  async delete(collection, id, opts) {
    return await this.registry.collection(collection).delete(id, opts);
  }
  get apollo() {
    return this.registry.apollo;
  }
};

// crud/history.ts
var HISTORY_ACTIONS = {
  update: "updated",
  insert: "added",
  delete: "deleted"
};
var HISTORY_ACCOUNTS_BY_ROLE = [
  "supplier_account",
  "cruise_manager_account"
];
function jsonDiff(activity) {
  const diff = [];
  if (activity.action == "insert") {
    for (const [key, value] of Object.entries(activity.data)) {
      diff.push({
        [key]: [
          null,
          value
        ]
      });
    }
  } else {
    for (const [key, value] of Object.entries(activity.data)) {
      if (activity.changes && Object.keys(activity.changes).includes(key)) {
        diff.push({
          [key]: [
            value,
            activity.changes[key]
          ]
        });
      }
    }
  }
  return diff;
}
__name(jsonDiff, "jsonDiff");

// crud/fetch.ts
var CrudFetch = class {
  static {
    __name(this, "CrudFetch");
  }
};

// fetch.ts
var ListFetchIncompleteError = class extends Error {
  static {
    __name(this, "ListFetchIncompleteError");
  }
  original;
  loaded;
  totalCount;
  constructor(original, loaded, totalCount) {
    super(`List incomplete: loaded ${loaded} of ${totalCount} rows (${original instanceof Error ? original.message : String(original)})`), this.original = original, this.loaded = loaded, this.totalCount = totalCount;
    this.name = "ListFetchIncompleteError";
  }
};
var ListFetch = class {
  static {
    __name(this, "ListFetch");
  }
  collectionName;
  asyncJoins;
  // join name -> foreign id -> joined object (objects of the joined collections, not T)
  joinCache = {};
  firstPageLimit = 50;
  pageLimit = 500;
  // incremented on every fetch() call, used to detect outdated fetch generations
  requestId = 0;
  // upper bound of rows loaded per fetch, protects browser memory
  maxRows = 1e5;
  constructor(collectionName, asyncJoins = true) {
    this.collectionName = collectionName;
    this.asyncJoins = asyncJoins;
  }
  get collection() {
    return Graphql.collection(this.collectionName);
  }
  // drop cached join objects, so the next fetch reloads them (e.g. on manual refresh)
  clearJoinCache() {
    this.joinCache = {};
  }
  async fetchJoin(name, result, eventHandler) {
    const definition = this.collection.definition.joins[name];
    const collection = this.collection.join(name);
    if (!definition || !collection || !collection.canSelect) return;
    const keyAttribute = definition.foreignKey || name + "_id";
    const idList = /* @__PURE__ */ new Set();
    const resultMap = {};
    for (const item of result) {
      if (item[name] != null) continue;
      const foreignId = item[keyAttribute];
      item[name] = null;
      if (foreignId) {
        if (!resultMap[foreignId]) resultMap[foreignId] = [];
        resultMap[foreignId].push(item);
      }
      if (this.joinCache[name] && this.joinCache[name][foreignId]) {
        item[name] = this.joinCache[name][foreignId];
      } else if (foreignId) {
        idList.add(foreignId);
      }
    }
    eventHandler("join.start", name);
    if (idList.size == 0) {
      eventHandler("join.end", name, []);
      return;
    }
    const joinResult = await collection.list({
      filter: {
        id: {
          _in: [
            ...idList
          ]
        }
      },
      skipJoins: true,
      includeDefaultJoins: true
    });
    for (const joinObject of joinResult) {
      if (resultMap[joinObject.id]) {
        for (const resultItem of resultMap[joinObject.id]) {
          resultItem[name] = joinObject;
        }
      }
      if (!this.joinCache[name]) this.joinCache[name] = {};
      this.joinCache[name][joinObject.id] = joinObject;
    }
    eventHandler("join.end", name, joinResult);
  }
  async fetchPage(options, eventHandler, isCurrent = () => true) {
    const collection = this.collection;
    const page = await collection.list(options);
    if (!isCurrent()) return page;
    eventHandler("joins.start", this.collectionName);
    const joinPromises = collection.joinNames.filter((join) => collection.listFields.indexOf(join) != -1).map((join) => this.fetchJoin(join, page, eventHandler).catch((e) => {
      console.error(`ListFetch(${this.collectionName}): failed to fetch join ${join}`, e);
    }));
    Promise.all(joinPromises).then(() => eventHandler("joins.end", this.collectionName)).catch((e) => console.error(`ListFetch(${this.collectionName}): joins.end handler failed`, e));
    eventHandler("collection.page", this.collectionName, page);
    return page;
  }
  // keyset paging: next page contains rows with an id below the last fetched row (order is id desc)
  buildNextPageFilter(baseFilter, lastItem) {
    const cursorFilter = {
      id: {
        _lt: lastItem.id
      }
    };
    return baseFilter ? {
      _and: [
        baseFilter,
        cursorFilter
      ]
    } : cursorFilter;
  }
  // loads all pages after the first one into result (in place)
  async fetchRemainingPages(result, totalCount, options, eventHandler, isCurrent) {
    const baseFilter = options.filter || options.where || null;
    try {
      let lastPage = result;
      let requested = this.firstPageLimit;
      while (isCurrent() && lastPage.length >= requested) {
        const remaining = this.maxRows - result.length;
        if (remaining <= 0) {
          if (totalCount > result.length) {
            console.warn(`ListFetch(${this.collectionName}): result truncated at ${result.length} of ${totalCount} rows`);
            eventHandler("collection.truncated", this.collectionName, result.length, totalCount);
          }
          break;
        }
        const lastItem = lastPage[lastPage.length - 1];
        if (lastItem?.id == null) {
          throw new Error(`ListFetch(${this.collectionName}): cannot page without id field`);
        }
        requested = Math.min(this.pageLimit, remaining);
        const page = await this.fetchPage({
          ...options,
          filter: this.buildNextPageFilter(baseFilter, lastItem),
          limit: requested
        }, eventHandler, isCurrent);
        if (!isCurrent()) return;
        result.push(...page);
        lastPage = page;
      }
      if (isCurrent()) eventHandler("collection.end", this.collectionName);
    } catch (e) {
      if (!isCurrent()) return;
      throw new ListFetchIncompleteError(e, result.length, totalCount);
    } finally {
      if (isCurrent()) eventHandler("done", this.collectionName);
    }
  }
  async fetch(options, eventHandler) {
    if (!eventHandler) eventHandler = /* @__PURE__ */ __name(() => {
    }, "eventHandler");
    const requestId = ++this.requestId;
    const isCurrent = /* @__PURE__ */ __name(() => requestId === this.requestId, "isCurrent");
    const collection = this.collection;
    options = {
      ...options
    };
    if (!options.fields) {
      const requiredRelations = {};
      collection.listFields.filter((listField) => collection.relationNames.indexOf(listField) >= 0).forEach((relationName) => {
        requiredRelations[relationName] = null;
      });
      options.fields = collection.buildFetchFields("list", null, this.asyncJoins, this.asyncJoins, null, requiredRelations);
    }
    options.order = [
      {
        "id": "desc"
      }
    ];
    eventHandler("collection.start", this.collectionName);
    const [totalCount, firstPage] = await Promise.all([
      collection.count(options),
      this.fetchPage({
        ...options,
        limit: this.firstPageLimit
      }, eventHandler, isCurrent)
    ]);
    const items = firstPage;
    if (!isCurrent()) return {
      items,
      totalCount,
      done: Promise.resolve()
    };
    eventHandler("collection.count", this.collectionName, totalCount);
    const done = this.fetchRemainingPages(items, totalCount, options, eventHandler, isCurrent);
    return {
      items,
      totalCount,
      done
    };
  }
};

// validation/index.ts
import joi from "@hapi/joi";

// validation/form.ts
var form_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "form",
    base: joi2.object(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      removeFields: {
        method(...fields) {
          return this.fork(fields, (field) => field.optional().meta({
            hidden: true
          }));
        },
        args: [
          {
            name: "fields",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "object", "assert"),
            message: "must be an array"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      readonlyFields: {
        method(...fields) {
          return this.fork(fields, (field) => field.optional().meta({
            readonly: true
          }));
        },
        args: [
          {
            name: "fields",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "object", "assert"),
            message: "must be an array"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      calculated: {
        method(keys) {
          const calculatedKeys = {};
          for (const key of Object.keys(keys)) {
            calculatedKeys[key] = keys[key].meta({
              readonly: true,
              disabled: true,
              hidden: true
            });
          }
          return this.append(calculatedKeys);
        },
        args: [
          {
            name: "keys",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "object", "assert"),
            message: "must be an object"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/text.ts
var text_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "text",
    base: joi2.string(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      rows: {
        method(rows) {
          return this.$_setFlag("rows", rows);
        },
        args: [
          {
            name: "rows",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "number", "assert"),
            message: "must be a number"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/time.ts
var time_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "time",
    //.regex(/^([0-9]{2})\:([0-9]{2})$/)
    base: joi2.string(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {}
  };
}), "default");

// validation/enum.ts
var enum_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "enum",
    base: joi2.alternatives(joi2.number().integer(), joi2.string()),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      items: {
        method(...values) {
          return this.allow(...values);
        },
        args: [
          {
            name: "values",
            ref: true,
            //assert: (value) => typeof value === 'array',
            message: "must be a array"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      itemMap: {
        method(items) {
          return this.allow(...Object.keys(items)).meta({
            itemMap: items
          });
        },
        args: [
          {
            name: "items",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "object", "assert"),
            message: "must be a object"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/percent.ts
var percent_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "percent",
    base: joi2.number(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {}
  };
}), "default");

// validation/price.ts
var price_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "price",
    base: joi2.number(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      currencySource: {
        method(path) {
          return this.$_setFlag("currencySource", path);
        },
        args: [
          {
            name: "path",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/color.ts
var color_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "color",
    base: joi2.string().regex(/^#[A-Fa-f0-9]{6}$/),
    messages: {
      "string.pattern.base": "{{#label}} must be a hex value. For example. #000000"
    },
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {}
  };
}), "default");

// validation/composit_price.ts
var composit_price_default = /* @__PURE__ */ __name(((Joi2) => {
  return {
    type: "compositPrice",
    base: Joi2.object().allow(null).meta({
      editor: "compositPrice",
      grid: 6
    }).keys({
      currency: Joi2.string().required(),
      type: Joi2.string().required(),
      tax_type: Joi2.string().required(),
      tax_rate: Joi2.number().required(),
      base_price: Joi2.object({
        price: Joi2.number().min(0).required(),
        type: Joi2.string().required()
      }).allow(null),
      tiers: Joi2.array().items(Joi2.object({
        min_quantity: Joi2.number().min(0).allow(null),
        items: Joi2.array().items(Joi2.object({
          type: Joi2.string(),
          price: Joi2.number()
        }))
      }))
    }),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      inherit: {
        method(target) {
          return this.$_setFlag("inherit", target);
        },
        args: [
          {
            name: "target",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/json.ts
var json_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "json",
    base: joi2.string(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      rows: {
        method(rows) {
          return this.$_setFlag("rows", rows);
        },
        args: [
          {
            name: "rows",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "number", "assert"),
            message: "must be a number"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/email.ts
var email_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "email",
    base: joi2.string(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {}
  };
}), "default");

// validation/phone.ts
import parsePhoneNumber from "libphonenumber-js";
var phone_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "phone",
    base: joi2.string(),
    messages: {
      "phone.isInvalid": "Is not a valid international phone numer!"
    },
    prepare(value, helpers) {
      const prepared = {
        value,
        errors: null
      };
      if (value) {
        const result = parsePhoneNumber(value);
        if (!result || !result.isValid()) {
          return {
            errors: [
              helpers.error("phone.isInvalid")
            ]
          };
        }
      }
      return prepared;
    }
  };
}), "default");

// validation/join.ts
var join_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "join",
    base: joi2.number().integer(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      collection: {
        method(name) {
          return this.$_setFlag("collection", name);
        },
        args: [
          {
            name: "name",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      composition: {
        method() {
          return this.$_setFlag("composition", true);
        },
        args: [],
        validate(value, helpers, args, options) {
        }
      },
      constrain: {
        method(filter) {
          return this.$_setFlag("constrain", filter);
        },
        args: [
          {
            name: "filter",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string" || typeof value === "object", "assert"),
            message: "must be a string or object"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      canCreate: {
        method() {
          return this.$_setFlag("create", true);
        },
        args: [],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/relation.ts
var relation_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "relation",
    base: joi2.object(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      collection: {
        method(name) {
          return this.$_setFlag("collection", name);
        },
        args: [
          {
            name: "name",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      },
      association: {
        method(owner, remote) {
          return this.$_setFlag("association", {
            owner,
            remote
          });
        },
        args: [
          {
            name: "owner",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          },
          {
            name: "remote",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/attributes.ts
var attributes_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "attributes",
    base: joi2.array(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      attribute: {
        method(name, label, validation) {
          const flag = this._flags.definition || [];
          flag.push({
            name,
            label,
            validation
          });
          return this.$_setFlag("definition", flag);
        },
        args: [
          {
            name: "name",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          },
          {
            name: "label",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          },
          {
            name: "validation",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => typeof value === "string", "assert"),
            message: "must be a string"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/checklist.ts
var checklist_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "checklist",
    base: joi2.array(),
    messages: {},
    coerce(value, helpers) {
    },
    validate(value, helpers) {
    },
    rules: {
      labels: {
        method(values) {
          return this.allow(...values).meta({
            items: values
          });
        },
        args: [
          {
            name: "values",
            ref: true,
            assert: /* @__PURE__ */ __name((value) => value.constructor.name === "Array", "assert"),
            message: "must be a array"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/list.ts
var list_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "list",
    base: joi2.array().allow(null),
    messages: {
      "list.emptyEntry": "has empty entries"
    },
    validate(value, helpers) {
      if (Array.isArray(value) && value.some((v) => !v || v.length === 0)) {
        return {
          value,
          errors: helpers.error("list.emptyEntry")
        };
      }
    },
    rules: {}
  };
}), "default");

// validation/asset.ts
var isPolicyArg = /* @__PURE__ */ __name((value) => typeof value === "string" || !!value && typeof value === "object" && typeof value.name === "string", "isPolicyArg");
var asset_default = /* @__PURE__ */ __name(((joi2) => {
  return {
    type: "asset",
    base: joi2.string().guid(),
    messages: {},
    rules: {
      policy: {
        method(policy) {
          if (!isPolicyArg(policy)) throw new Error("Invalid asset policy: must be a policy name or an asset policy object");
          let result = this.$_setFlag("policy", typeof policy === "string" ? policy : policy.name);
          if (typeof policy !== "string") {
            if (policy.mimeTypes) result = result.$_setFlag("accept", [
              ...policy.mimeTypes
            ]);
            if (typeof policy.maxSize === "number") result = result.$_setFlag("maxSize", policy.maxSize);
          }
          return result;
        },
        args: [
          {
            name: "policy",
            ref: false,
            assert: isPolicyArg,
            message: "must be a policy name or an asset policy object"
          }
        ],
        validate(value, helpers, args, options) {
        }
      }
    }
  };
}), "default");

// validation/index.ts
var Joi = joi.extend(phone_default, email_default, form_default, text_default, time_default, enum_default, percent_default, price_default, color_default, composit_price_default, json_default, join_default, relation_default, attributes_default, checklist_default, list_default, asset_default);

// currency.ts
function formatCurrency(input, currency = "EUR", locale = "DE", morePrecision = false) {
  if (input === null || input === void 0) return null;
  const formatter = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: morePrecision ? 4 : 2,
    style: "currency",
    currency
  });
  input = parseFloat(String(input));
  if (!morePrecision && input.toFixed(2) == "-0.00") {
    return formatter.format(0);
  }
  return formatter.format(input);
}
__name(formatCurrency, "formatCurrency");
var currencyRates = {
  EUR: 1
};
async function getCurrencyRate(currency) {
  if (!currency) throw new Error("No currency given");
  if (!currencyRates[currency]) {
    const rates = await Graphql.collection("currency_rate").list({
      filter: {
        currency: {
          code: {
            _eq: currency
          }
        }
      },
      limit: 1,
      order: [
        {
          date: "asc"
        }
      ]
    });
    if (rates.length > 0) {
      currencyRates[currency] = rates[0].rate;
    } else {
      throw new Error("No currency rate for: " + currency);
    }
  }
  return currencyRates[currency];
}
__name(getCurrencyRate, "getCurrencyRate");
async function convertCurrencyToBase(currency, value) {
  const rate = await getCurrencyRate(currency);
  const result = value * (1 / rate);
  return parseFloat(result.toFixed(2));
}
__name(convertCurrencyToBase, "convertCurrencyToBase");

// date.ts
import moment from "moment";
import "moment/locale/de";
function formatDate(input, options) {
  if (!input) return;
  if (!options) options = {
    short: false
  };
  const locale = options && options.locale || "de";
  let format = "dd., ll";
  if (options.short == true) format = "DD MMM YYYY";
  else if (options.iso == true) format = "YYYY-MM-DD";
  else if (options.format) format = options.format;
  return moment(input).locale(locale).format(format);
}
__name(formatDate, "formatDate");
function formatIsoDate(input) {
  return formatDate(input, {
    iso: true
  });
}
__name(formatIsoDate, "formatIsoDate");
function formatDatetime(input, options) {
  if (!input) return;
  if (!options) options = {};
  const locale = options && options.locale || "de";
  let format = "YYYY-MM-DD - HH:mm";
  if (options?.format == "time") format = "LT";
  else if (options?.format == "date") format = "ll";
  else if (options.format) format = options.format;
  return moment(input).format(format);
}
__name(formatDatetime, "formatDatetime");
function currentYear(input) {
  if (!input) return moment().format("YYYY");
  return moment(input).format("YYYY");
}
__name(currentYear, "currentYear");
function addDayMonthYear(input, day, month, year) {
  if (!input) return;
  return moment(input).add(day, "days").add(month, "months").add(year, "years").format("YYYY-MM-DD");
}
__name(addDayMonthYear, "addDayMonthYear");
function isValidDate(input) {
  if (!input) return;
  return moment(input, "YYYY-MM-DD", true).isValid();
}
__name(isValidDate, "isValidDate");

// time.ts
import _11 from "lodash";
import moment2 from "moment";
var TimeAmount = class _TimeAmount {
  static {
    __name(this, "TimeAmount");
  }
  seconds;
  constructor(seconds) {
    this.seconds = seconds;
  }
  format(precise = false) {
    const negative = this.seconds < 0;
    const amount = Math.abs(this.seconds);
    const hours = Math.floor(amount / 3600);
    const minutes = Math.floor(amount / 60) % 60;
    const seconds = amount % 60;
    const hStr = _11.padStart(hours.toString(), 2, "0");
    const mStr = _11.padStart(minutes.toString(), 2, "0");
    const sStr = _11.padStart(seconds.toString(), 2, "0");
    const prefix = negative ? "-" : "";
    if (precise) return `${prefix}${hStr}:${mStr}:${sStr}`;
    else return `${prefix}${hStr}:${mStr}`;
  }
  static parse(input) {
    if (!input || !input.toString().trim()) return null;
    const negative = input.startsWith("-");
    const amount = negative ? input.substring(1) : input;
    let [hours, minutes, seconds] = amount.split(":").map((p) => Math.abs(Number(p)));
    if (!hours) hours = 0;
    if (!minutes) minutes = 0;
    if (!seconds) seconds = 0;
    let totalSeconds = seconds + minutes * 60 + hours * 60 * 60;
    if (negative) totalSeconds = totalSeconds * -1;
    return new _TimeAmount(totalSeconds);
  }
  static for(amount, unit) {
    switch (unit) {
      case "seconds":
        return new _TimeAmount(amount);
      case "minutes":
        return new _TimeAmount(amount * 60);
      case "hours":
        return new _TimeAmount(amount * 60 * 60);
      default:
        throw new Error("Unknown duration unit: " + unit);
    }
  }
};
function formatTime(input) {
  if (!input) return;
  return moment2(input, "HH:mm:ss").format("HH:mm");
}
__name(formatTime, "formatTime");
function isValidTime(input) {
  if (!input) return true;
  if (typeof input !== "string") {
    return moment2(input).isValid();
  }
  const timeString = input.startsWith("-") ? input.substring(1) : input;
  return moment2(timeString, "HH:mm", true).isValid();
}
__name(isValidTime, "isValidTime");
function parseTimeAmount(input) {
  if (!input) return null;
  let [h, m, s] = input.split(":").map((i) => parseInt(i)).map((i) => _11.isNaN(i) || _11.isUndefined(i) ? 0 : i);
  if (_11.isUndefined(h)) h = 0;
  if (_11.isUndefined(m)) m = 0;
  if (_11.isUndefined(s)) s = 0;
  const parsed = {
    pretty: input,
    hours: null,
    minutes: null,
    seconds: null
  };
  parsed.seconds = h * 60 * 60 + m * 60 + s;
  parsed.minutes = parsed.seconds / 60;
  parsed.hours = parsed.minutes / 60;
  parsed.pretty = `${_11.padStart(h.toString(), 2, "0")}:${_11.padStart(m.toString(), 2, "0")}:${_11.padStart(s.toString(), 2, "0")}`;
  return parsed;
}
__name(parseTimeAmount, "parseTimeAmount");
function addTimeAmount(...items) {
  const result = {
    pretty: null,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  for (const item of items) {
    result.hours += item.hours;
    result.minutes += item.minutes;
    result.seconds += item.seconds;
  }
  const h = Math.floor(result.seconds / 3600);
  const m = Math.floor(result.seconds % 3600 / 60);
  const s = Math.round(result.seconds % 60);
  result.pretty = `${_11.padStart(h.toString(), 2, "0")}:${_11.padStart(m.toString(), 2, "0")}:${_11.padStart(s.toString(), 2, "0")}`;
  return result;
}
__name(addTimeAmount, "addTimeAmount");
function roundTimeAmountByMinutes(item, precision = 30, fn = "ceil") {
  const result = {
    ...item
  };
  result.minutes = Math[fn](result.minutes / precision) * precision;
  result.seconds = result.minutes * 60;
  result.hours = result.minutes / 60;
  const h = Math.floor(result.seconds / 3600);
  const m = Math.floor(result.seconds % 3600 / 60);
  const s = Math.round(result.seconds % 60);
  result.pretty = `${_11.padStart(h.toString(), 2, "0")}:${_11.padStart(m.toString(), 2, "0")}:${_11.padStart(s.toString(), 2, "0")}`;
  return result;
}
__name(roundTimeAmountByMinutes, "roundTimeAmountByMinutes");
function isMorning(time, format = "HH:mm:ss") {
  if (!time) return;
  return moment2(time, format).isSameOrAfter(moment2("00:00", format)) && moment2(time, format).isBefore(moment2("12:00", format));
}
__name(isMorning, "isMorning");
function isMidDay(time, format = "HH:mm:ss") {
  if (!time) return;
  return moment2(time, format).isSameOrAfter(moment2("12:00", format)) && moment2(time, format).isBefore(moment2("16:00", format));
}
__name(isMidDay, "isMidDay");
function isEvening(time, format = "HH:mm:ss") {
  if (!time) return;
  return moment2(time, format).isSameOrAfter(moment2("16:00", format)) && moment2(time, format).isBefore(moment2("24:00", format));
}
__name(isEvening, "isEvening");

// app/context.ts
import axios from "axios";

// app/apollo.ts
import ws from "ws";
import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, split } from "@apollo/client/core";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import * as Util from "apollo-utilities";
import * as GraphQlWs from "graphql-ws";
var ApolloBuilder = class {
  static {
    __name(this, "ApolloBuilder");
  }
  context;
  constructor(context) {
    this.context = context;
  }
  get config() {
    return this.context.config;
  }
  authLink() {
    return setContext((request) => new Promise((success, fail) => {
      const headers = {};
      if (this.config.graphqlAuthToken) {
        headers["Authorization"] = `Bearer ${this.config.graphqlAuthToken}`;
      } else if (this.config.graphqlAdminSecret) {
        headers["X-Hasura-Admin-Secret"] = this.config.graphqlAdminSecret;
      }
      success({
        headers
      });
    }));
  }
  setContextTokenLink() {
    return new ApolloLink((operation, forward) => {
      const context = operation.getContext();
      if (context.apiToken) {
        delete context.headers["X-Hasura-Admin-Secret"];
        context.headers["Authorization"] = "Bearer " + context.apiToken;
      }
      return forward(operation).map((data) => {
        return data;
      });
    });
  }
  removeTypenameLink() {
    return new ApolloLink((operation, forward) => {
      if (operation.variables) {
        const omitTypename = /* @__PURE__ */ __name((key, value) => key === "__typename" ? void 0 : value, "omitTypename");
        operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
      }
      return forward(operation).map((data) => {
        return data;
      });
    });
  }
  logErrorsLink() {
    return onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        for (const graphqlError of graphQLErrors) {
          console.error(`GraphQL-Error: ${graphqlError.message} Path: ${graphqlError.path}`);
          console.error(graphqlError);
          this.context.dispatch("apollo:graphql-error", graphqlError);
        }
      }
      if (networkError) {
        console.error(`Network-Error: ${networkError.message}`);
        if ("statusCode" in networkError) {
          console.error(`HTTP Status Code: ${networkError.statusCode}`);
        } else if (networkError.stack) {
          console.error(networkError.stack);
        }
        this.context.dispatch("apollo:graphql-error", networkError);
      }
    });
  }
  transportHttpLink() {
    return ApolloLink.from([
      this.setContextTokenLink(),
      new HttpLink({
        uri: this.config.graphqlEndpointHttp,
        headers: {}
      })
    ]);
  }
  transportWsLink() {
    return new GraphQLWsLink(GraphQlWs.createClient({
      url: this.config.graphqlEndpointWs,
      lazy: true,
      webSocketImpl: typeof window == "undefined" ? ws : window["WebSocket"],
      connectionParams: /* @__PURE__ */ __name(() => {
        return {
          headers: {
            Authorization: `Bearer ${this.config.graphqlAuthToken}`
          }
        };
      }, "connectionParams")
    }));
  }
  transportLink() {
    return split(({ query }) => {
      const definition = Util.getMainDefinition(query);
      return definition.kind === "OperationDefinition" && definition.operation === "subscription";
    }, this.transportWsLink(), this.transportHttpLink());
  }
  buildClient() {
    const link = ApolloLink.from([
      this.removeTypenameLink(),
      this.logErrorsLink(),
      this.authLink(),
      this.transportLink()
    ]);
    const cache = new InMemoryCache();
    const resolvers = {};
    const defaultOptions = {
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all"
      }
    };
    if (!this.config.graphqlMode) {
      throw new Error("GraphQL mode is not set. Set either client or server in app config!");
    }
    const client = new ApolloClient({
      link,
      cache,
      resolvers,
      defaultOptions,
      //connectToDevTools: true
      queryDeduplication: this.config.graphqlMode === "client"
    });
    return client;
  }
};

// app/context.ts
import gql5 from "graphql-tag";
import { Log as Log2, i18n } from "@hc/base";

// app/events.ts
var AppEvents = class {
  static {
    __name(this, "AppEvents");
  }
  handlers = {};
  on(event, handler) {
    if (event instanceof Array) {
      for (const singleEvent of event) {
        this.on(singleEvent, handler);
      }
    } else {
      if (!this.handlers.hasOwnProperty(event)) {
        this.handlers[event] = [];
      }
      this.handlers[event].push(handler);
    }
  }
  dispatch(event, target) {
    if (!this.handlers.hasOwnProperty(event)) {
      return;
    }
    for (const handler of this.handlers[event]) {
      handler(event, target);
    }
  }
};

// app/config.ts
import UriJs from "urijs";
var AppConfig = class {
  static {
    __name(this, "AppConfig");
  }
  graphqlEndpointBase = "localhost:9050/v1/graphql";
  graphqlEndpointSSL = false;
  graphqlAdminSecret;
  graphqlAuthToken;
  graphqlMode;
  debug = false;
  rollbar = {
    accessToken: "fac81e24ea604b88b60e52d9cbd146c6",
    enabled: false,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.NODE_ENV || "development",
    verbose: false,
    populate_empty_backtraces: true
  };
  constructor() {
    if (typeof process === "undefined") return;
    if (process.env.WONDERLAND_GRAPHQL_ADMIN_SECRET) {
      this.graphqlAdminSecret = process.env.WONDERLAND_GRAPHQL_ADMIN_SECRET;
    }
    if (process.env.WONDERLAND_GRAPHQL_AUTH_TOKEN) {
      this.graphqlAdminSecret = process.env.WONDERLAND_GRAPHQL_AUTH_TOKEN;
    }
  }
  get graphqlEndpointHttp() {
    return (this.graphqlEndpointSSL ? "https" : "http") + "://" + this.graphqlEndpointBase;
  }
  get graphqlEndpointWs() {
    return (this.graphqlEndpointSSL ? "wss" : "ws") + "://" + this.graphqlEndpointBase;
  }
  set graphqlEndpoint(value) {
    const uri = UriJs(value);
    this.graphqlEndpointBase = uri.host() + uri.path();
    this.graphqlEndpointSSL = uri.protocol() == "https";
  }
};

// app/context.ts
var AppContext = class {
  static {
    __name(this, "AppContext");
  }
  crud;
  // the server config keys are only set after the ui bootstrap loaded config.json
  config = new AppConfig();
  events = new AppEvents();
  _apollo;
  constructor(crud) {
    this.crud = crud;
  }
  get i18n() {
    return i18n;
  }
  getLogger(name) {
    return Log2.getLogger(name);
  }
  get schema() {
    return schema_default;
  }
  get apollo() {
    if (!this._apollo) {
      this._apollo = new ApolloBuilder(this).buildClient();
      this.events.dispatch("apollo:init", this._apollo);
    }
    return this._apollo;
  }
  async query(queryString, variables = {}) {
    const query = gql5("{" + queryString + "}");
    const result = await this.apollo.query({
      query
    });
    return result.data;
  }
  crudCollection(name) {
    return schema_default.collection(name);
  }
  get crudCollections() {
    return Object.values(schema_default.collections);
  }
  async graphql(query) {
    const response = await axios.post(this.config.graphqlEndpointHttp, {
      query,
      variables: null
    });
    const body = response.data;
    return body.data;
  }
  on(event, handler) {
    this.events.on(event, handler);
  }
  dispatch(event, target) {
    this.events.dispatch(event, target);
  }
};

// exception.ts
function parseDependentDeleteException(message) {
  if (message.includes("Foreign key violation")) {
    const [collection, , relation] = message.match(/"(.*?)"/g);
    let collectionTitle = collection.substring(1, collection.length - 1);
    let relationTitle = relation.substring(1, relation.length - 1);
    collectionTitle = Graphql.collection(collectionTitle).titleSingular;
    relationTitle = Graphql.collection(relationTitle).titleSingular;
    return `Could not delete ${collectionTitle} as it has been used in a ${relationTitle}. Do you want to archive(hide) this ${collectionTitle} instead?`;
  } else return "Something went wrong. Please try again later.";
}
__name(parseDependentDeleteException, "parseDependentDeleteException");
export {
  ApolloBuilder,
  AppConfig,
  AppContext,
  AppEvents,
  CrudAccess,
  CrudAccessGroup,
  CrudAuth,
  CrudCollection,
  CrudFetch,
  CrudFormSchemaBuilder,
  CrudMutation,
  CrudQuery,
  CrudSchema,
  CrudTransaction,
  CrudWorkflow,
  CrudWorkflowAction,
  CrudWorkflowDownloadAction,
  Graphql,
  GraphqlFormSchema,
  GraphqlSchema,
  GraphqlSchemaRegistry,
  GraphqlTableSchema,
  HISTORY_ACCOUNTS_BY_ROLE,
  HISTORY_ACTIONS,
  Joi,
  ListFetch,
  ListFetchIncompleteError,
  TimeAmount,
  addDayMonthYear,
  addTimeAmount,
  auth,
  camelize,
  convertCurrencyToBase,
  crudAccessRules,
  currentYear,
  formatCurrency,
  formatDate,
  formatDatetime,
  formatIsoDate,
  formatTime,
  getCurrencyRate,
  isEvening,
  isMidDay,
  isMorning,
  isValidDate,
  isValidTime,
  jsonDiff,
  objectPath,
  parseDependentDeleteException,
  parseTimeAmount,
  roundTimeAmountByMinutes,
  titleize3 as titleize
};
//# sourceMappingURL=index.mjs.map